import type { ScheduledTask, ExecutionRecord } from "./scheduled-tasks-types"

const now = Date.now()
const DAY = 86400000

export const MOCK_TASKS: ScheduledTask[] = [
  {
    id: "task-001",
    name: "每日安全资讯摘要",
    prompt: "汇总今日国内外安全资讯，重点关注漏洞披露、攻击事件和政策动态，生成简要报告",
    schedule_type: "daily",
    schedule_time: "09:00",
    status: "active",
    directory: "/tmp",
    last_run_at: now - DAY,
    next_run_at: now + 3600000,
    time_created: now - 7 * DAY,
    time_updated: now - 2 * DAY,
  },
  {
    id: "task-002",
    name: "漏洞情报周报",
    prompt: "整理本周重要 CVE 漏洞情报，分析影响范围和修复建议，按严重程度排序输出周报",
    schedule_type: "weekly",
    schedule_time: "10:00",
    schedule_weekday: 1,
    status: "active",
    directory: "/tmp",
    last_run_at: now - 3 * DAY,
    next_run_at: now + 4 * DAY,
    time_created: now - 14 * DAY,
    time_updated: now - 5 * DAY,
  },
  {
    id: "task-003",
    name: "代码依赖风险巡检",
    prompt: "扫描项目第三方依赖，检查已知 CVE 漏洞和许可证合规风险，生成依赖安全报告",
    schedule_type: "monthly",
    schedule_time: "02:00",
    schedule_month_day: 1,
    status: "paused",
    directory: "/tmp",
    last_run_at: now - 20 * DAY,
    next_run_at: now + 10 * DAY,
    time_created: now - 30 * DAY,
    time_updated: now - 20 * DAY,
  },
  {
    id: "task-004",
    name: "Web 应用安全巡检",
    prompt: "对目标 Web 应用执行自动化安全扫描，检测 OWASP Top 10 风险并生成检测报告",
    schedule_type: "daily",
    schedule_time: "03:00",
    status: "active",
    directory: "/tmp",
    last_run_at: now - DAY,
    next_run_at: now + 7200000,
    time_created: now - 10 * DAY,
    time_updated: now - DAY,
  },
]

export const MOCK_HISTORY: ExecutionRecord[] = [
  {
    id: "exec-001",
    task_id: "task-001",
    status: "success",
    trigger_type: "scheduled",
    time_started: now - DAY,
    time_finished: now - DAY + 45000,
    error_message: undefined,
  },
  {
    id: "exec-002",
    task_id: "task-004",
    status: "success",
    trigger_type: "scheduled",
    time_started: now - DAY + 7200000,
    time_finished: now - DAY + 7200000 + 120000,
    error_message: undefined,
  },
  {
    id: "exec-003",
    task_id: "task-002",
    status: "success",
    trigger_type: "scheduled",
    time_started: now - 3 * DAY,
    time_finished: now - 3 * DAY + 60000,
    error_message: undefined,
  },
  {
    id: "exec-004",
    task_id: "task-001",
    status: "failed",
    trigger_type: "scheduled",
    time_started: now - 2 * DAY,
    time_finished: now - 2 * DAY + 30000,
    error_message: "数据源连接超时，无法获取安全资讯数据",
  },
  {
    id: "exec-005",
    task_id: "task-003",
    status: "success",
    trigger_type: "scheduled",
    time_started: now - 20 * DAY,
    time_finished: now - 20 * DAY + 90000,
    error_message: undefined,
  },
]

export function generateId(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
}
